export default __webpack_public_path__ + "static/media/back_3.aef6b7ff.png";